import { EnvironmentTO } from "../../backend-definitions.module";

export type TotemNodeType = "CATEGORY" | "ACTION" | "MODEL";

export type TotemActionType = "GENERATE_PASSWORD" | "SEARCH_PATIENT";

// nó da árvore
export interface TotemNode {
    _uid: string;
    name: string;
    type: TotemNodeType;
    modelPassword: string;
    action?: TotemActionType;
    children?: TotemNode[];
    expandable?: boolean;
    environment: EnvironmentTO;
    typePassword?: string;
    companyId?: number;
    companyName?: string;
    totemSchedule?: any;
    totemParentName?: string;
}

// modelo raiz (o que será salvo no banco)
export class TotemModel {
    id: number;
    name: string;
    value?: any;
    type: TotemNodeType;
    dateAt: string;
}

export interface TotemNodeDialogResult {
    _uid: string;
    name: string;
    type: TotemNodeType;
    modelPassword: string;
    action?: TotemActionType;
}
